module.exports = __webpack_public_path__ + "img/Track@2x.967861de.png";